module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDIwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMTAuNDc3NSA4Ljk5OTAyTDIuMjUwMyAyLjI0OTAyTDE4LjcwNDggMi4yNDkwMkwxMC40Nzc1IDguOTk5MDJaIiBmaWxsPSIjREJDMzlCIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beginnersOnly/next.svg
// module id = DgEN
// module chunks = 0